import { Box, Switch, TextField, Typography, Select, MenuItem, FormControl } from "@mui/material";

const COUNTRIES = [
  { code: "+91", name: "India", flag: "🇮🇳" },
  { code: "+1", name: "USA", flag: "🇺🇸" },
  { code: "+44", name: "UK", flag: "🇬🇧" },
  { code: "+61", name: "Australia", flag: "🇦🇺" },
  { code: "+971", name: "UAE", flag: "🇦🇪" },
  { code: "+966", name: "Saudi Arabia", flag: "🇸🇦" },
  { code: "+65", name: "Singapore", flag: "🇸🇬" },
  { code: "+49", name: "Germany", flag: "🇩🇪" },
  { code: "+33", name: "France", flag: "🇫🇷" },
  { code: "+81", name: "Japan", flag: "🇯🇵" },
  { code: "+86", name: "China", flag: "🇨🇳" },
  { code: "+55", name: "Brazil", flag: "🇧🇷" },
  { code: "+7", name: "Russia", flag: "🇷🇺" },
  { code: "+27", name: "South Africa", flag: "🇿🇦" },
  { code: "+234", name: "Nigeria", flag: "🇳🇬" },
  { code: "+92", name: "Pakistan", flag: "🇵🇰" },
  { code: "+880", name: "Bangladesh", flag: "🇧🇩" },
  { code: "+62", name: "Indonesia", flag: "🇮🇩" },
  { code: "+60", name: "Malaysia", flag: "🇲🇾" },
  { code: "+63", name: "Philippines", flag: "🇵🇭" },
  { code: "+39", name: "Italy", flag: "🇮🇹" },
  { code: "+34", name: "Spain", flag: "🇪🇸" },
  { code: "+52", name: "Mexico", flag: "🇲🇽" },
  { code: "+82", name: "South Korea", flag: "🇰🇷" },
  { code: "+90", name: "Turkey", flag: "🇹🇷" },
];

const glassCard = { p: 2, borderRadius: 3, bgcolor: "rgba(255,255,255,0.7)", backdropFilter: "blur(8px)", border: "1px solid rgba(229,231,235,0.6)", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" };

const MobileNumberTab = ({ skipOption, setSkipOption, errorMessage, setErrorMessage, validations, setValidations, settings, setSettings }) => {
  const defaultCountry = settings?.defaultCountry || "+91";
  const ipDetection = settings?.ipDetection ?? true;

  return (
    <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={glassCard}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1f2937" }}>Skip Option</Typography>
            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Allow visitors to skip</Typography>
          </Box>
          <Switch checked={skipOption} onChange={(e) => setSkipOption(e.target.checked)} size="small" />
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Default Country</Typography>
        <FormControl fullWidth size="small">
          <Select value={defaultCountry} onChange={(e) => setSettings({ ...settings, defaultCountry: e.target.value })}
            sx={{ borderRadius: 2, bgcolor: "#fff", fontSize: 12 }}>
            {COUNTRIES.map(c => (
              <MenuItem key={c.code} value={c.code}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ fontSize: 14 }}>{c.flag}</Typography>
                  <Typography sx={{ fontSize: 12 }}>{c.name} ({c.code})</Typography>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ ...glassCard, bgcolor: ipDetection ? "rgba(240,253,244,0.8)" : "rgba(255,255,255,0.7)", border: ipDetection ? "1px solid #bbf7d0" : "1px solid rgba(229,231,235,0.6)" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1f2937" }}>Auto-detect Country</Typography>
            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Set code based on visitor's IP</Typography>
          </Box>
          <Switch checked={ipDetection} onChange={(e) => setSettings({ ...settings, ipDetection: e.target.checked })} size="small" color="success" />
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Validation</Typography>
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <TextField fullWidth label="Min Digits" type="number" size="small"
            value={validations?.minLength ?? ""} onChange={(e) => setValidations({ ...validations, minLength: Number(e.target.value) || undefined })}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
          <TextField fullWidth label="Max Digits" type="number" size="small"
            value={validations?.maxLength ?? ""} onChange={(e) => setValidations({ ...validations, maxLength: Number(e.target.value) || undefined })}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
        </Box>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Error Message</Typography>
        <TextField fullWidth placeholder="Please enter a valid mobile number" value={errorMessage} size="small"
          onChange={(e) => setErrorMessage(e.target.value)}
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
      </Box>
    </Box>
  );
};

export default MobileNumberTab;
